import * as React from 'react';
import { AuthorizedUserContext } from '../components/PhoneChangePage/types';

interface AuthorizedUserContextType {
  authorizedUserContext: AuthorizedUserContext;
  setAuthorizedUserContext: (context: AuthorizedUserContext) => void;
}

const AuthorizedUserContextObj = React.createContext<AuthorizedUserContextType>({
  authorizedUserContext: {
    appUrl: '',
    phoneVerificationRequired: false,
    redirectError: null,
    isIpRestricted: false,
  },
  setAuthorizedUserContext: () => {},
});

const AuthorizedUserContextProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [authorizedUserContext, setAuthorizedUserContext] = React.useState<AuthorizedUserContext>({
    appUrl: '',
    phoneVerificationRequired: false,
    redirectError: null,
    isIpRestricted: false,
  });

  return (
    <AuthorizedUserContextObj.Provider value={{ authorizedUserContext, setAuthorizedUserContext }}>
      {children}
    </AuthorizedUserContextObj.Provider>
  );
};

function useAuthorizedUserContext(): AuthorizedUserContextType {
  const context = React.useContext(AuthorizedUserContextObj);
  return context;
}

export { AuthorizedUserContextProvider, useAuthorizedUserContext };
